module.exports = __webpack_public_path__ + "static/RobotoSlab-ExtraLight-3fa296384846c42bb0a847a73620f3d0.ttf";